import React, { useEffect } from 'react';

import NumberKeys from './NumberKeys';
import IncrementKeys from './IncrementKeys';
import KeyboardButton from './KeyboardButton';
import Freebets from '../Freebets';
import AcceptOddsChanges from '../AcceptOddsChanges';

import {
    useKeyboard,
    ANIMATION_DURATION,
} from '~Betslip/store/keyboardContext';
import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';

import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import {
    selectBetslipGTMComponent,
    selectDisplayFullslip,
} from '~Betslip/selectors/uiSelectors';

import {
    selectHasInplay,
} from '~Betslip/selectors/selectionDetailsSelectors';

import {
    sendHapticFeedbackLight,
} from '~spa/Utils/HapticFeedback';

import { useBetslipKeypadAnimationEnabled } from '~SpectateStore/hooks/clientStateHooks';

import { AnimatePresence, motion } from 'framer-motion';

import './styles.scss';

const AcceptKey = () => {
    const { closeKeyboard } = useKeyboard();

    const gtmComponent = useSelector(selectBetslipGTMComponent);

    const onAcceptKeyClick = () => {
        closeKeyboard();
        sendHapticFeedbackLight();
    };

    return (
        <div className="fullslip__accept-key">
            <KeyboardButton
                keyText={'accept'}
                clickHandler={onAcceptKeyClick}
                dataTestId={'betslip-keyboard;button-done'}
                gtmAttribute={`${gtmComponent};stake-area;confirm`}
            />
        </div>
    );
};

const Keyboard = () => {
    const { keyboardContainerRef, isKeyboardVisible } = useKeyboard();
    const isUserLoggedIn = useIsUserLoggedIn();
    const isAnimationEnabled = useBetslipKeypadAnimationEnabled();
    const displayFullslip = useSelector(selectDisplayFullslip);
    const hasInplay = useSelector(selectHasInplay);
    const displayAcceptOddsChanges = !displayFullslip && hasInplay;

    useEffect(() => {
        setTimeout(() => {
            keyboardContainerRef?.scrollIntoView({
                block: 'nearest',
            });
        }, isAnimationEnabled ? ANIMATION_DURATION : 0);
    }, []);

    const renderAcceptOddsFreebets = () => {
        if (!isUserLoggedIn) {
            return null;
        }

        if (displayAcceptOddsChanges) {
            return (
                <>
                    <AcceptOddsChanges source="new-baby-betslip"/>
                    <Freebets />
                </>
            );
        }

        return <Freebets />;
    };

    const renderKeyboard = () => (
        <div>
            {
                renderAcceptOddsFreebets()
            }
            <div className="fullslip__keyboard">
                <NumberKeys />
                <IncrementKeys />
                <AcceptKey />
            </div>
        </div>
    );

    if (!isAnimationEnabled) {
        return renderKeyboard();
    }

    const transition = {
        ease: 'easeOut',
        duration: ANIMATION_DURATION / 1000,
    };

    return (
        <AnimatePresence>
            {isKeyboardVisible && (
                <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: 'auto' }}
                    exit={{ height: 0 }}
                    transition={transition}
                    style={{ overflow: 'hidden' }}
                >
                    {renderKeyboard()}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Keyboard;
